import type { AuditTrailEventDescriptionField } from '../../model'

/** Collects all searchable text from a fields array (including nested subFields) */
export function collectFieldSearchText(fields: AuditTrailEventDescriptionField[]): string {
  const parts: string[] = []
  for (const field of fields) {
    parts.push(field.label)
    for (const value of field.values) {
      if (value.current) parts.push(value.current)
      if (value.previous) parts.push(value.previous)
      if (value.diff) parts.push(...value.diff)
    }
    if (field.subFields) parts.push(collectFieldSearchText(field.subFields))
  }
  return parts.join(' ')
}
